<template>
  <transition name="slide">
    <div v-if="visible" class="report-sidebar">
      <div class="sidebar-header">
        <h3>{{ title }}</h3>
        <button class="close-btn" @click="$emit('close')">×</button>
      </div>

      <div class="sidebar-content">
        <iframe :src="report" class="report-iframe"></iframe>
      </div>

      <div class="qrcode-section" v-if="url">
         <img id="qrcode-container" :src="url" alt="">
        <p class="qrcode-tip">请使用 微信 扫码分享给学员</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ReportSidebar',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      required: true,
    },
    report: {
      type: String,
      default: () => ({}),
    },
    title: {
      type: String,
      default: '学习报告',
    },
  },
  data() {
    return {
    };
  },
  methods: {
    getFullUrl(url) {
      const { origin } = window.location;
      if (url.startsWith('/')) {
        return `${origin}${url}`;
      }
      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
.report-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  width: 40%;
  height: 100%;
  background-color: #fff;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #eaecef;

  h3 {
    margin: 0;
    font-size: 18px;
  }

  .close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    padding: 0 8px;
    line-height: 24px;
    border-radius: 4px;

    &:hover {
      background-color: #f5f5f5;
    }
  }
}

.sidebar-content {
  flex: 1;
  // overflow: auto;

  .report-iframe {
    width: 100%; /* 改为100%自适应 */
    height: 100%;
    border: none;
    min-width: 300px;
  }
}

.qrcode-section {
  position: absolute;
  left: -208px;
  bottom: 20px;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;

  #qrcode-container {
    width: 180px;
    height: 180px;
    margin: 0 auto;

    img {
      display: block;
      margin: 0 auto;
    }
  }

  .qrcode-tip {
    margin: 10px 0 0;
    font-size: 12px;
    color: #666;
  }
}

// 滑入动画
.slide-enter-active {
  animation: slide-in 0.3s;
}
.slide-leave-active {
  animation: slide-in 0.3s reverse;
}
@keyframes slide-in {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}
</style>
